export default __webpack_public_path__ + "static/media/services_04.c2de1cfb.jpg";